export function workAgreementVersionHeader(version: number | undefined): HeadersInit {
  if (!Number.isInteger(version) || version === undefined || version <= 0) {
    throw new Error("Cannot change a work agreement without its current version.");
  }
  return { "If-Match": `"${version}"` };
}
